// extracted by mini-css-extract-plugin
module.exports = {"roles-page-container":"roles_roles-page-container__3p50m"};